import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    AfterViewInit
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from 'src/app/modules/shared/events/bsModal.events';
import {ShoppingListComponent} from './shopping-list.component';
import * as moment from 'moment';
import {DiaryService} from '../../../../shared/services/diary.service';
import {UsersService} from '../../../../shared/services/users.service';
import {AppLoadingEventsEmitter} from '../../../../shared/events/loading.events';
import {MealViewModel} from '../../../../shared/viewModels/meal.viewModel';
import {VmvMissingProducts} from '../../../../shared/viewModels/vmvCreateOrder.viewModel';

@Component({
    selector: 'app-vmv',
    templateUrl: './vmv.component.html',
    styleUrls: ['./vmv.component.scss'],
})
export class VmvComponent implements OnInit, AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    shoppingListComponent: ShoppingListComponent;
    email = '';
    meals: MealViewModel[];
    checkedMeals = {};
    isSuccess: boolean = null;

    showMissingProducts = false;
    missingProducts: VmvMissingProducts[];

    constructor(
        public readonly bsModalRef: BsModalRef,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly diaryService: DiaryService,
        private readonly usersService: UsersService,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
    ) {
    }

    ngOnInit() {
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        if (this.usersService.userProfile) {
            this.meals = this.usersService.userProfile.daily_meals.meals;

            for (const meal of this.meals) {
                this.checkedMeals[meal.id] = true;
            }

            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        }
    }

    getFromDate() {
        if (!this.shoppingListComponent) {
            return '';
        }

        return moment(this.shoppingListComponent.fromDate).format('DD.MM.YYYY');
    }

    getToDate() {
        if (!this.shoppingListComponent) {
            return '';
        }

        return moment(this.shoppingListComponent.toDate).format('DD.MM.YYYY');
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    // save() {
    //     if (this.email.length > 3 && this.isEmailValid(this.email)) {
    //         this.diaryService.sendShoppingListAccess(
    //             this.email,
    //             moment(this.shoppingListComponent.fromDate).format('YYYY-MM-DD'),
    //             moment(this.shoppingListComponent.toDate).format('YYYY-MM-DD')
    //         ).subscribe(() => {
    //             this.isSuccess = true;
    //         }, () => {
    //             this.isSuccess = false;
    //         });
    //     }
    // }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    isIOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    }

    createVmvOrder(isForceCreateOrder: boolean = false) {
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        const checkedMealIds = [];

        for (const meal of this.meals) {
            if (this.checkedMeals[meal.id]) {
                checkedMealIds.push(meal.id);
            }
        }

        if (checkedMealIds.length > 0) {
            console.log(this.datesInRange(this.shoppingListComponent.fromDate, this.shoppingListComponent.toDate));

            this.diaryService.createVmvOrder({
                userId: this.usersService.userProfile.id,
                dates: this.datesInRange(this.shoppingListComponent.fromDate, this.shoppingListComponent.toDate),
                orderMealIds: checkedMealIds,
                forceCreateOrder: isForceCreateOrder
            }).subscribe(response => {

                if (response.createdOrderId == null || response.createdOrderId.length <= 0) {
                    if (response.missingProducts.length > 0) {
                        this.showMissingProducts = true;
                        this.missingProducts = response.missingProducts;

                        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                    } else {
                        this.isSuccess = false;
                        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                    }
                } else {
                    this.isSuccess = true;
                    this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);

                    window.open('https://vmv.bg/basket/' + response.createdOrderId, '_blank');
                }

            }, () => {
                this.isSuccess = false;
                this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            });
        }
    }

    private datesInRange(startDate, endDate) {
        const dates = [
            moment(startDate).startOf('day').format('YYYY-MM-DD')
        ];

        const currDate = moment(startDate).startOf('day');
        const lastDate = moment(endDate).startOf('day');

        while (currDate.add(1, 'days').diff(lastDate) <= 0) {
            dates.push(moment(currDate.clone().toDate()).format('YYYY-MM-DD'));
        }

        return dates;
    }
}
